import { Stack } from "@mui/material";
import { RoundHeatStatus } from "../heat/RoundHeatStatus";

export const RunsHeader = ({ heats, runBased }) => (
    <Stack spacing={0.5}>
        {heats.map((heat) => (
            <RoundHeatStatus
                key={heat.position}
                heat={heat}
                runBased={runBased}
            />
        ))}
    </Stack>
);
